/**
 * assets/collection-swatches.js
 *
 * Cross-product colour swatches on the collection grid. Clicking a
 * swatch updates that card's image, price and link (via Shopify's
 * lightweight /products/{handle}.js endpoint) in place, without a
 * page navigation and without creating a duplicate card. The
 * underlying links always point at the real product URL, so nothing
 * here affects crawlability, filtering or pagination.
 */
(function () {
  if (window.__collectionSwatchesLoaded) return;
  window.__collectionSwatchesLoaded = true;

  function getMoneyFormat() {
    var section = document.querySelector('[data-money-format]');
    return (section && section.getAttribute('data-money-format')) || '${{amount}}';
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Helpers && typeof window.theme.Helpers.formatMoney === 'function') {
      return window.theme.Helpers.formatMoney(cents, getMoneyFormat());
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCard(card, data) {
    var imageWrapper = card.querySelector('[data-grouped-card-image]');
    if (imageWrapper) {
      var img = imageWrapper.querySelector('img');
      if (img && data.featured_image) {
        var newSrc = data.featured_image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '$1?width=600');
        img.src = newSrc;
        img.removeAttribute('srcset');
      }
    }

    var priceWrapper = card.querySelector('[data-grouped-card-price]');
    if (priceWrapper) {
      var priceEl = priceWrapper.querySelector('.price');
      var onSale = data.compare_at_price && data.compare_at_price > data.price;
      if (priceEl) priceEl.classList.toggle('price--on-sale', !!onSale);

      var regular = priceWrapper.querySelector('.price-item--regular');
      var sale = priceWrapper.querySelector('.price__sale .price-item--sale');
      if (onSale) {
        if (sale) sale.textContent = formatMoney(data.price);
        var compareRegular = priceWrapper.querySelector('.price__sale .price-item--regular');
        if (compareRegular) compareRegular.textContent = formatMoney(data.compare_at_price);
      } else if (regular) {
        regular.textContent = formatMoney(data.price);
      }
    }

    card.querySelectorAll('[data-grouped-card-link]').forEach(function (link) {
      link.setAttribute('href', data.url);
    });
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-collection-swatches] [data-colour-swatch]');
    if (!swatch) return;

    var url = swatch.getAttribute('data-swatch-url');
    if (!url) return;

    var card = swatch.closest('.product-index');
    if (!card) return;

    event.preventDefault();

    var swatchesContainer = swatch.closest('[data-collection-swatches]');
    swatchesContainer.querySelectorAll('[data-colour-swatch]').forEach(function (el) {
      el.classList.toggle('is-active', el === swatch);
      el.setAttribute('aria-current', el === swatch ? 'true' : 'false');
    });

    fetch(url + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product fetch failed');
        return response.json();
      })
      .then(function (data) {
        updateCard(card, data);
      })
      .catch(function () {
        /* leave the card as-is; the swatch link itself still points at a valid product URL */
      });
  });
})();
